import React from 'react'
import ReactDOM from 'react-dom'
import LoadStyles from '@driftt/tide-core/dist/styles'

import App from 'layouts/App'
import { rootReducer, rootEpic } from 'modules'
import ConnectedApp  from '@driftt/traffic-control'
import config from 'config'

import 'babel-polyfill'

import './index.css'

ReactDOM.render(
  <ConnectedApp
    epics={rootEpic}
    reducers={rootReducer}
    render={() => <App/>}
    authClientId={config.AUTH_CLIENT_ID}
    sentryId={config.SENTRY_DSN}
  />,
  document.getElementById('root'))

LoadStyles()
window.noop = () => {}
